<template>
  <div class="page-wrap">

    <!-- ── Page Header ── -->
    <div class="page-header">
      <div class="page-header__left">
        <button class="btn-back" @click="$router.back()">
          <i class="fa fa-arrow-left"></i>
        </button>
        <div>
          <h1 class="page-title">Credit History</h1>
          <span class="page-subtitle">User #{{ id }}</span>
        </div>
      </div>
      <div class="balance-card" v-if="loaded">
        <div class="balance-card__label">Current Balance</div>
        <div class="balance-card__val">{{ balance }} AED</div>
      </div>
    </div>

    <!-- ── Table ── -->
    <div class="table-panel" v-if="loaded">
      <div class="table-responsive-wrap">
        <table class="dd-table">
          <thead>
          <tr>
            <th>#</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Cart</th>
            <th>Comment</th>
            <th>Created At</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in transactions"
              :key="index"
              class="dd-table__row"
          >
            <td class="row-num">{{ index + 1 }}</td>
            <td>
                <span :class="['action-badge', item.type === 'Deposit' ? 'action-badge--deposit' : 'action-badge--withdraw']">
                  <i :class="item.type === 'Deposit' ? 'fa fa-arrow-down' : 'fa fa-arrow-up'"></i>
                  {{ item.type }}
                </span>
            </td>
            <td>
                <span :class="['amount-val', item.type === 'Deposit' ? 'amount-val--pos' : 'amount-val--neg']">
                  {{ item.type === 'Deposit' ? '+' : '-' }}{{ Math.abs(item.amount) }} {{ item.currency }}
                </span>
            </td>
            <td>
                <span
                    class="link-cell"
                    v-if="item.cart_id"
                    @click="$router.push(`/carts/${item.cart_id}`)"
                >#{{ item.cart_id }}</span>
              <span class="text-muted" v-else>—</span>
            </td>
            <td>
                <span
                    class="comment-text"
                    v-if="item.comment"
                    :title="item.comment"
                >{{ item.comment }}</span>
              <span class="text-muted" v-else>—</span>
            </td>
            <td class="date-cell">{{ formatDate(item.created_at) || '—' }}</td>
          </tr>

          <tr v-if="transactions && transactions.length === 0">
            <td colspan="6" class="empty-state">
              <i class="fa fa-exchange"></i>
              <div>No transactions found</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Loading -->
    <div class="mt-5 pt-5">
      <loading v-if="!loaded"></loading>
    </div>

  </div>
</template>

<script>
import { config } from "../helpers";

export default {
  name: "UserWalletHistory",
  data() {
    return {
      url: "",
      id: this.$route.params.id,
      balance: 0,
      loaded: false,
      transactions: [],
    };
  },

  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/users";
    this.loadData();
  },

  methods: {
    loadData() {
      axios.get(`${this.url}/${this.id}/wallet-history`).then((r) => {
        this.transactions = r.data.data.transactions;
        this.balance      = r.data.data.balance;
        this.loaded       = true;
      });
    },

    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()} ${d.getHours()}:${String(d.getMinutes()).padStart(2,"0")}`;
    },
  },
};
</script>

<style scoped>
.page-wrap  { display: flex; flex-direction: column; gap: 16px; }

/* ── Header ── */
.page-header { display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.page-header__left { display: flex; align-items: flex-start; gap: 12px; }
.btn-back { width: 34px; height: 34px; margin-top: 4px; background: var(--bg-hover); border: 1px solid var(--border); border-radius: 8px; color: var(--text-2); cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: border-color .15s, color .15s; }
.btn-back:hover { border-color: var(--accent); color: var(--accent); }
.page-title   { font-size: 20px; font-weight: 500; color: var(--text-1); margin: 0 0 2px; }
.page-subtitle { font-size: 12px; color: var(--text-3); }

/* ── Balance card ── */
.balance-card { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; padding: .9rem 1.25rem; text-align: right; }
.balance-card__label { font-size: 11px; color: var(--text-3); text-transform: uppercase; letter-spacing: .5px; margin-bottom: 4px; }
.balance-card__val   { font-size: 22px; font-weight: 600; color: #22c55e; }

/* ── Table ── */
.table-panel { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
.table-responsive-wrap { overflow-x: auto; }
.dd-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dd-table thead tr { border-bottom: 1px solid var(--border); }
.dd-table th { padding: 10px 14px; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; color: var(--text-3); text-align: left; white-space: nowrap; }
.dd-table td { padding: 12px 14px; color: var(--text-2); border-bottom: 1px solid var(--border); vertical-align: middle; }
.dd-table__row:hover td { background: var(--bg-hover); }
.dd-table tr:last-child td { border-bottom: none; }

.row-num { font-size: 12px; color: var(--text-3); font-weight: 500; }

/* Action badge */
.action-badge { display: inline-flex; align-items: center; gap: 5px; padding: 3px 9px; border-radius: 20px; font-size: 11px; font-weight: 500; white-space: nowrap; }
.action-badge--deposit  { background: rgba(34,197,94,.12);  color: #22c55e; border: 1px solid rgba(34,197,94,.25); }
.action-badge--withdraw { background: rgba(244,47,75,.12);  color: #f42f4b; border: 1px solid rgba(244,47,75,.25); }

/* Amount */
.amount-val      { font-weight: 600; font-size: 14px; }
.amount-val--pos { color: #22c55e; }
.amount-val--neg { color: #f42f4b; }

.link-cell { color: var(--accent); cursor: pointer; font-weight: 500; }
.link-cell:hover { text-decoration: underline; }
.text-muted { color: var(--text-3); font-size: 12px; }

.comment-text { font-size: 12px; color: var(--text-2); max-width: 200px; display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; cursor: help; border-bottom: 1px dashed var(--border-2); }

.date-cell { font-size: 12px; color: var(--text-3); white-space: nowrap; }

.empty-state { text-align: center; padding: 3rem 1rem !important; color: var(--text-3); }
.empty-state i { font-size: 32px; display: block; margin-bottom: 8px; }
</style>
